<div class="col-12">
  <button
    type="button"
    class="float-right mb-3 AddNewBTN"
    (click)="documentService.tab = 3"
  >Add New
</button>
</div>
<div class="col-12">
  <p-table [value]="documents" [paginator]="true" *ngIf="documents.length > 0" [rows]="5">
    <ng-template pTemplate="header">
      <tr>
        <th [pSortableColumn]="'folders'">Folders
          <p-sortIcon [field]="'folders'"></p-sortIcon>
        </th>
        <th [pSortableColumn]="'fileName'">Name
          <p-sortIcon [field]="'fileName'"></p-sortIcon>
        </th>
        <th [pSortableColumn]="'ext'">Type
          <p-sortIcon [field]="'ext'"></p-sortIcon>
        </th>
        <th [pSortableColumn]="'createdByName'">Uploaded By
          <p-sortIcon [field]="'createdByName'"></p-sortIcon>
        </th>
        <th [pSortableColumn]="'notes'">Notes
          <p-sortIcon [field]="'notes'"></p-sortIcon>
        </th>
        <th [pSortableColumn]="'createdAt'">Created At
          <p-sortIcon [field]="'createdAt'"></p-sortIcon>
        </th>
        <th></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-document>
      <tr>
        <td>{{ document.folders}}</td>
        <td>{{ document.niceName }}</td>
        <td>{{ document.ext }}</td>
        <td>{{ document.createdByName }}</td>
        <td>{{ document.notes }}</td>
        <td>{{ document.createdAt|date:'MM/dd/yyyy | HH:mm' }}</td>
        <td class="text-right">
          <!-- <button  type="button" (click)="downloadDocument(document)" class="ui-button-rounded ui-button-secondary"> <i class="pi pi-spin pi-spinner" [hidden]="!document.isDownloading"></i> Download</button> -->
          <!-- <button  type="button" (click)="deleteDocument(document)" class="ui-button-rounded ui-button-secondary bg-red text-white">Delete</button> -->
          <p-button icon="pi pi-download" styleClass="p-button-rounded p-button-secondary p-button-text" (click)="downloadDocument(document)"><i class="pi pi-spin pi-spinner" [hidden]="!document.isDownloading"></i></p-button>
          <p-button icon="pi pi-trash" styleClass="p-button-rounded p-button-secondary p-button-text" (click)="deleteDocument(document)"></p-button>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
<p-toast position="top-right"></p-toast> 